// src/config/baslikConfig/variableCatalog.js
// Degisken katalogu: DXF baslik sablonlarindaki text alanlarina baglanabilecek degiskenler

import { getFirmaInfo } from '../../services/firmaInfo';

// Proje (Projects sayfası) metadata alanlarını başlık değişkenlerine bağlayan tablo.
// baslik.* path için form değeri boşsa proje metadata'sından otomatik gelsin.
//   key:   baslik.* path (variableCatalog'daki path ile aynı)
//   value: function(projectMetadata) → resolved string (veya '')
const PROJECT_META_FALLBACKS = {
  // ─── Proje Sorumlusu (Elektrik Müellifi) ───
  'baslik.projeSorumlusu.adiSoyadi':    m => m.elektrikMuellif || '',
  'baslik.projeSorumlusu.odaNo':        m => m.authorChamberNo || '',
  'baslik.projeSorumlusu.diplomaNo':    m => m.authorDiplomaNo || '',
  'baslik.projeSorumlusu.vergiSicilNo': m => m.authorTaxRegNo || '',
  'baslik.projeSorumlusu.vergiDairesi': m => m.authorTaxOffice || '',

  // ─── Proje Uygulama Sorumlusu (boşsa müellif kullanılır) ───
  'baslik.projeUygulamaSorumlusu.adiSoyadi':    m => m.implManagerName       || m.elektrikMuellif || '',
  'baslik.projeUygulamaSorumlusu.odaNo':        m => m.implManagerChamberNo  || m.authorChamberNo || '',
  'baslik.projeUygulamaSorumlusu.diplomaNo':    m => m.implManagerDiplomaNo  || m.authorDiplomaNo || '',
  'baslik.projeUygulamaSorumlusu.vergiSicilNo': m => m.implManagerTaxRegNo   || m.authorTaxRegNo  || '',
  'baslik.projeUygulamaSorumlusu.vergiDairesi': m => m.implManagerTaxOffice  || m.authorTaxOffice || '',

  // ─── Proje Müellifi ───
  'baslik.projeMuellifi.projeMuellifi': m => m.elektrikMuellif || '',
  'baslik.projeMuellifi.onayKurum':     m => m.approvalAuthority || '',
  'baslik.projeMuellifi.belediye':      m => m.municipality || (m.district ? `${m.district} Belediyesi` : ''),
  'baslik.projeMuellifi.yapiDenetim':   m => m.buildingInspectionCo || '',

  // ─── Projeyi Yaptıran ←  Paydaşlar (Mal Sahibi) + Adres ───
  'baslik.projeyiYaptiran.adiSoyadi':     m => m.malSahibi || m.client || '',
  'baslik.projeyiYaptiran.adres':         m => [m.neighborhood, m.street].filter(Boolean).join(' '),
  'baslik.projeyiYaptiran.ilceIl':        m => [m.district, m.city].filter(Boolean).join(' / '),
  'baslik.projeyiYaptiran.vergiDairesiNo':m => [m.ownerTaxOffice, m.ownerTaxNo].filter(Boolean).join(' / '),

  // ─── Arsa Özellikleri ← Adres + Paydaşlar ───
  'baslik.arsaOzellikleri.il':            m => m.city || '',
  'baslik.arsaOzellikleri.ilce':          m => m.district || '',
  'baslik.arsaOzellikleri.ilceIl':        m => [m.district, m.city].filter(Boolean).join(' / '),
  'baslik.arsaOzellikleri.pafta':         m => m.pafta || '',
  'baslik.arsaOzellikleri.ada':           m => m.ada || '',
  'baslik.arsaOzellikleri.parsel':        m => m.parsel || '',
  'baslik.arsaOzellikleri.adres':         m => [m.neighborhood, m.street, m.district, m.city].filter(Boolean).join(', '),
  'baslik.arsaOzellikleri.yapiSahibiAdi': m => m.malSahibi || m.client || '',
  'baslik.arsaOzellikleri.vergiNo':       m => [m.ownerTaxOffice, m.ownerTaxNo].filter(Boolean).join(' / '),

  // ─── Yapı Özellikleri ← Genel + Künye ───
  'baslik.yapiOzellikleri.toplamKat':         m => m.floorCount ? String(m.floorCount) : '',
  'baslik.yapiOzellikleri.yapiSinifi':        m => m.buildingClass || '',
  'baslik.yapiOzellikleri.yapimSuresi':       m => m.constructionDuration || '',
  'baslik.yapiOzellikleri.toplamAlan':        m => m.buildingArea ? String(m.buildingArea) : '',
  'baslik.yapiOzellikleri.kullanimAmaci':     m => m.purposeOfUse || '',
  'baslik.yapiOzellikleri.cizen':             m => m.drawnBy || '',
  'baslik.yapiOzellikleri.cizimTarihi':       () => new Date().toLocaleDateString('tr-TR'),
  'baslik.yapiOzellikleri.olcek':             m => m.scale || '',
  'baslik.yapiOzellikleri.projeNo':           m => m.projectNo || '',
  'baslik.yapiOzellikleri.bagimsizBolSayisi': m => m.independentUnits ? String(m.independentUnits) : '',
};

export const VARIABLE_CATALOG = [
  {
    category: 'Proje Sorumlusu',
    variables: [
      { path: 'baslik.projeSorumlusu.adiSoyadi', label: 'Adi Soyadi' },
      { path: 'baslik.projeSorumlusu.odaNo', label: 'Oda No' },
      { path: 'baslik.projeSorumlusu.diplomaNo', label: 'Diploma No' },
      { path: 'baslik.projeSorumlusu.vergiSicilNo', label: 'Vergi Sicil No' },
      { path: 'baslik.projeSorumlusu.vergiDairesi', label: 'Vergi Dairesi' },
    ],
  },
  {
    category: 'Proje Uygulama Sorumlusu',
    variables: [
      { path: 'baslik.projeUygulamaSorumlusu.adiSoyadi', label: 'Adi Soyadi' },
      { path: 'baslik.projeUygulamaSorumlusu.odaNo', label: 'Oda No' },
      { path: 'baslik.projeUygulamaSorumlusu.diplomaNo', label: 'Diploma No' },
      { path: 'baslik.projeUygulamaSorumlusu.vergiSicilNo', label: 'Vergi Sicil No' },
      { path: 'baslik.projeUygulamaSorumlusu.vergiDairesi', label: 'Vergi Dairesi' },
    ],
  },
  {
    category: 'Proje Muellifi',
    variables: [
      { path: 'baslik.projeMuellifi.projeMuellifi', label: 'Proje Muellifi' },
      { path: 'baslik.projeMuellifi.onayKurum', label: 'Onay Kurum' },
      { path: 'baslik.projeMuellifi.belediye', label: 'Belediye' },
      { path: 'baslik.projeMuellifi.yapiDenetim', label: 'Yapi Denetim' },
    ],
  },
  {
    category: 'Projeyi Yaptiran',
    variables: [
      { path: 'baslik.projeyiYaptiran.adiSoyadi', label: 'Adi Soyadi' },
      { path: 'baslik.projeyiYaptiran.adres', label: 'Adres' },
      { path: 'baslik.projeyiYaptiran.ilceIl', label: 'Ilce / Il' },
      { path: 'baslik.projeyiYaptiran.vergiDairesiNo', label: 'Vergi Dairesi / No' },
    ],
  },
  {
    category: 'Arsa Ozellikleri',
    variables: [
      { path: 'baslik.arsaOzellikleri.yapiSahibiAdi', label: 'Yapi Sahibi Adi' },
      { path: 'baslik.arsaOzellikleri.adres', label: 'Adres' },
      { path: 'baslik.arsaOzellikleri.ilceIl', label: 'Ilce / Il' },
      { path: 'baslik.arsaOzellikleri.vergiNo', label: 'Vergi No' },
      { path: 'baslik.arsaOzellikleri.il', label: 'Il' },
      { path: 'baslik.arsaOzellikleri.ilce', label: 'Ilce' },
      { path: 'baslik.arsaOzellikleri.pafta', label: 'Pafta' },
      { path: 'baslik.arsaOzellikleri.ada', label: 'Ada' },
      { path: 'baslik.arsaOzellikleri.parsel', label: 'Parsel' },
    ],
  },
  {
    category: 'Yapi Ozellikleri',
    variables: [
      { path: 'baslik.yapiOzellikleri.toplamKat', label: 'Toplam Kat' },
      { path: 'baslik.yapiOzellikleri.yapiSinifi', label: 'Yapi Sinifi' },
      { path: 'baslik.yapiOzellikleri.yapimSuresi', label: 'Yapim Suresi' },
      { path: 'baslik.yapiOzellikleri.toplamAlan', label: 'Toplam Alan (m2)' },
      { path: 'baslik.yapiOzellikleri.kullanimAmaci', label: 'Kullanim Amaci' },
      { path: 'baslik.yapiOzellikleri.eskiGuc', label: 'Eski Guc (W)' },
      { path: 'baslik.yapiOzellikleri.eklenenGuc', label: 'Eklenen Guc (W)' },
      { path: 'baslik.yapiOzellikleri.topKuruluGuc', label: 'Top. Kurulu Guc (W)' },
      { path: 'baslik.yapiOzellikleri.cizen', label: 'Cizen' },
      { path: 'baslik.yapiOzellikleri.cizimTarihi', label: 'Cizim Tarihi' },
      { path: 'baslik.yapiOzellikleri.olcek', label: 'Olcek' },
      { path: 'baslik.yapiOzellikleri.projeNo', label: 'Proje No' },
      { path: 'baslik.yapiOzellikleri.bagimsizBolSayisi', label: 'Bagimsiz Bol. Sayisi' },
      { path: 'baslik.yapiOzellikleri.talepFaktoru', label: 'Talep Faktoru (%)' },
      { path: 'baslik.yapiOzellikleri.talepGuc', label: 'Talep Guc (W)' },
    ],
  },
  {
    category: 'Hesaplanan Degerler',
    variables: [
      { path: 'computed.toplamKuruluGuc', label: 'Toplam Kurulu Guc (hesaplanan)' },
      { path: 'computed.toplamAkim', label: 'Toplam Akim (hesaplanan)' },
    ],
  },
  {
    category: 'Proje — Adres',
    variables: [
      { path: 'proje.city',             label: 'İl' },
      { path: 'proje.district',         label: 'İlçe' },
      { path: 'proje.neighborhood',     label: 'Mahalle' },
      { path: 'proje.street',           label: 'Cadde / Sokak' },
      { path: 'proje.ada',              label: 'Ada' },
      { path: 'proje.pafta',            label: 'Pafta' },
      { path: 'proje.parsel',           label: 'Parsel' },
    ],
  },
  {
    category: 'Proje — Genel',
    variables: [
      { path: 'proje.phone',                label: 'Telefon' },
      { path: 'proje.landArea',             label: 'Arsa Alanı (m²)' },
      { path: 'proje.buildingArea',         label: 'İnşaat Alanı (m²)' },
      { path: 'proje.floorCount',           label: 'Kat Adedi' },
      { path: 'proje.buildingClass',        label: 'Yapı Sınıfı' },
      { path: 'proje.independentUnits',     label: 'Bağımsız Bölüm' },
      { path: 'proje.meterCount',           label: 'Sayaç Sayısı' },
      { path: 'proje.projectNo',            label: 'Proje No' },
      { path: 'proje.purposeOfUse',         label: 'Kullanım Amacı' },
      { path: 'proje.constructionDuration', label: 'Yapım Süresi' },
      { path: 'proje.scale',                label: 'Ölçek' },
      { path: 'proje.drawnBy',              label: 'Çizen' },
    ],
  },
  {
    category: 'Proje — Paydaşlar',
    variables: [
      { path: 'proje.malSahibi',         label: 'Mal Sahibi' },
      { path: 'proje.client',            label: 'Müşteri' },
      { path: 'proje.muteahhit',         label: 'Müteahhit' },
      { path: 'proje.mimariMuellif',     label: 'Mimari Müellif' },
      { path: 'proje.elektrikMuellif',   label: 'Elektrik Müellif' },
      { path: 'proje.mekanikMuellif',    label: 'Mekanik Müellif' },
      { path: 'proje.kontrolMuhendis',   label: 'Kontrol Mühendisi' },
      { path: 'proje.approvalAuthority', label: 'Onay Yapacak Kurum' },
      { path: 'proje.municipality',      label: 'Belediye' },
      { path: 'proje.buildingInspectionCo', label: 'Yapı Denetim Şirketi' },
    ],
  },
  {
    category: 'Proje — Müellif Mesleki',
    variables: [
      { path: 'proje.authorChamberNo',  label: 'Müellif Oda No' },
      { path: 'proje.authorDiplomaNo',  label: 'Müellif Diploma No' },
      { path: 'proje.authorTaxRegNo',   label: 'Müellif Vergi Sicil No' },
      { path: 'proje.authorTaxOffice',  label: 'Müellif Vergi Dairesi' },
      { path: 'proje.implManagerName',      label: 'Uygulama Sorumlusu Adı' },
      { path: 'proje.implManagerChamberNo', label: 'Uygulama Sorumlusu Oda No' },
      { path: 'proje.implManagerDiplomaNo', label: 'Uygulama Sorumlusu Diploma No' },
      { path: 'proje.implManagerTaxRegNo',  label: 'Uygulama Sorumlusu Vergi Sicil No' },
      { path: 'proje.implManagerTaxOffice', label: 'Uygulama Sorumlusu Vergi Dairesi' },
    ],
  },
  {
    category: 'Proje — Yapı Sahibi',
    variables: [
      { path: 'proje.ownerTaxOffice', label: 'Yapı Sahibi Vergi Dairesi' },
      { path: 'proje.ownerTaxNo',     label: 'Yapı Sahibi Vergi No' },
    ],
  },
];

/**
 * Redux state'ten dot-path ile deger cozucu.
 * - `baslik.*` -> state.baslik.defaults.*
 * - `computed.*` -> simpleSupply'dan hesaplanan degerler
 */
export function resolveVariablePath(reduxState, path) {
  if (!path || !reduxState) return '';

  const parts = path.split('.');

  if (parts[0] === 'baslik') {
    // baslik.projeSorumlusu.adiSoyadi -> AKTİF PAFTANIN başlık kaydı
    // (state.baslik.byTab[activeTab].projeSorumlusu.adiSoyadi)
    let current = reduxState.baslik?.byTab?.[reduxState.baslik?.activeTab]
      || reduxState.baslik?.defaults; // geriye dönük (eski .jbz)
    for (let i = 1; i < parts.length; i++) {
      if (current == null) { current = null; break; }
      current = current[parts[i]];
    }
    const formValue = (current == null || current === '') ? '' : String(current);
    if (formValue) return formValue;
    // Form değeri boşsa proje metadata'sından (Projects sayfası) otomatik doldur
    const fallbackFn = PROJECT_META_FALLBACKS[path];
    if (fallbackFn) {
      const meta = reduxState.project?.projectMetadata || {};
      const v = fallbackFn(meta);
      return v ? String(v) : '';
    }
    return '';
  }

  if (parts[0] === 'proje') {
    // proje.<key> -> state.project.projectMetadata.<key> direkt erişim
    const meta = reduxState.project?.projectMetadata || {};
    const key = parts[1];
    const v = meta[key];
    return (v == null || v === '') ? '' : String(v);
  }

  if (parts[0] === 'computed') {
    const key = parts[1];
    const ss = reduxState.simpleSupply;
    if (!ss) return '';

    switch (key) {
      case 'toplamKuruluGuc': {
        // Toplam kurulu guc: tum component'lerin guclerinin toplami
        const components = ss.components || [];
        const total = components.reduce((sum, c) => sum + (c.power || 0), 0);
        return total > 0 ? String(total) : '';
      }
      case 'toplamAkim': {
        // Toplam akim: feeders'daki toplam akim
        const feeders = ss.feeders || [];
        const total = feeders.reduce((sum, f) => sum + (f.current || 0), 0);
        return total > 0 ? total.toFixed(2) : '';
      }
      default:
        return '';
    }
  }

  return '';
}

// ─── Başlık paneli OTOMATİK DOLDURMA ─────────────────────────────────────────
// Panel alanlarını (baslik.defaults) BOŞ olanları hesaptan + projeden + supply'dan
// doldurmak için. Kaynak öncelik: projectMetadata → hesap (firmaInfo) → supply.

// Hesap (firmaInfo.getFirmaInfo) → baslik alan fallback'leri (proje sorumlusu/müellif)
const ACCOUNT_FALLBACKS = {
  'baslik.projeSorumlusu.adiSoyadi':    f => f.sorumlu.adiSoyadi,
  'baslik.projeSorumlusu.odaNo':        f => f.sorumlu.odaNo,
  'baslik.projeSorumlusu.diplomaNo':    f => f.sorumlu.diplomaNo,
  'baslik.projeSorumlusu.vergiSicilNo': f => f.sorumlu.vergiSicilNo,
  'baslik.projeSorumlusu.vergiDairesi': f => f.sorumlu.vergiDairesi,
  'baslik.projeUygulamaSorumlusu.adiSoyadi':    f => f.sorumlu.adiSoyadi,
  'baslik.projeUygulamaSorumlusu.odaNo':        f => f.sorumlu.odaNo,
  'baslik.projeUygulamaSorumlusu.diplomaNo':    f => f.sorumlu.diplomaNo,
  'baslik.projeUygulamaSorumlusu.vergiSicilNo': f => f.sorumlu.vergiSicilNo,
  'baslik.projeUygulamaSorumlusu.vergiDairesi': f => f.sorumlu.vergiDairesi,
  'baslik.projeMuellifi.projeMuellifi': f => f.sorumlu.adiSoyadi,
};

// Supply (simpleSupply) → baslik güç alanları
function supplyFallback(path, ss) {
  if (!ss) return '';
  const components = ss.components || [];
  const mainPanel = components.find(c => c?.electrical?.installedPower != null) || null;
  const installed = mainPanel?.electrical?.installedPower;
  const demand = mainPanel?.electrical?.demandPower;
  switch (path) {
    case 'baslik.yapiOzellikleri.eklenenGuc':
      return installed != null ? String(Math.round(installed)) : '';
    case 'baslik.yapiOzellikleri.topKuruluGuc': {
      const total = components.reduce((s, c) => s + (c.power || 0), 0);
      return total > 0 ? String(Math.round(total)) : '';
    }
    case 'baslik.yapiOzellikleri.talepGuc':
      return demand != null ? String(Math.round(demand)) : '';
    default:
      return '';
  }
}

/**
 * Başlık defaults'undaki BOŞ alanlar için otomatik değerleri çözer.
 * @returns {Object} { sectionKey: { field: value } } — yalnızca boş olan alanlar
 */
export function resolveBaslikAutofill(reduxState) {
  const meta = reduxState.project?.projectMetadata || {};
  const ss = reduxState.simpleSupply;
  const defaults = reduxState.baslik?.byTab?.[reduxState.baslik?.activeTab]
    || reduxState.baslik?.defaults || {}; // geriye dönük (eski .jbz)
  let firma = null;
  try { firma = getFirmaInfo(); } catch { firma = null; }

  const out = {};
  const setVal = (path, value) => {
    if (!value) return;
    const parts = path.split('.'); // baslik.section.field
    const section = parts[1], field = parts[2];
    if (!section || !field) return;
    const cur = defaults[section]?.[field];
    if (cur != null && cur !== '') return;          // dolu alanı ATLA
    if (!out[section]) out[section] = {};
    if (!out[section][field]) out[section][field] = value; // ilk gelen kazanır
  };

  // 1. Proje metadata'sı (mevcut PROJECT_META_FALLBACKS)
  for (const [path, fn] of Object.entries(PROJECT_META_FALLBACKS)) {
    if (!path.startsWith('baslik.')) continue;
    try { setVal(path, fn(meta)); } catch (_) { /* yoksay */ }
  }
  // 2. Hesap (firmaInfo) — metadata boşsa
  if (firma) {
    for (const [path, fn] of Object.entries(ACCOUNT_FALLBACKS)) {
      try { setVal(path, fn(firma)); } catch (_) { /* yoksay */ }
    }
  }
  // 3. Supply (güç alanları)
  for (const path of [
    'baslik.yapiOzellikleri.eklenenGuc',
    'baslik.yapiOzellikleri.topKuruluGuc',
    'baslik.yapiOzellikleri.talepGuc',
  ]) {
    setVal(path, supplyFallback(path, ss));
  }

  return out;
}
